import { IconButton, Stack, Typography } from '@mui/material';
import { theme } from '@src/theme';
import { FC } from 'react';
import { ReactComponent as TrashIcon } from '@icons/trash.svg';

type TagProps = {
  startContent?: JSX.Element;
  contentText: string;
  onDelete?: (val: string) => void;
  value: string;
};

export const Tag: FC<TagProps> = ({ startContent, contentText, onDelete, value }) => {
  const hundleDelete = () => onDelete && onDelete(value);
  return (
    <Stack direction="row" gap="6px">
      <Stack padding="6px 12px" direction="row" bgcolor={theme.palette.secondary['200']} width="100%">
        {startContent}
        <Typography variant="label14Medium" lineHeight="18px" color="secondary.main">
          {contentText}
        </Typography>
      </Stack>
      {onDelete && (
        <IconButton
          onClick={hundleDelete}
          sx={{ padding: '0 9px', '& svg path': { fill: theme.palette.secondary.main } }}
        >
          <TrashIcon />
        </IconButton>
      )}
    </Stack>
  );
};
